import { gql } from '@apollo/client';

export const BOOKING_FORM_DATA = gql`
  query bookingFormData {
    hostGroupsOverview {
      id
      title
    }
    hostsOverview {
      id
      position
      group_id
      alias
      client_sessions {
        id
        finished_at
        started_at
      }
      bookings {
        id
        from
        to
        group
      }
    }
  }
`;

export const GET_BOOKING = gql`
  query getBookingV2($id: Int!) {
    getBooking(id: $id) {
      id
      group
      comment
      hostIds
      from
      to
      client {
        uuid
        id
      }
    }
  }
`;

export const CREATE_BOOKING = gql`
  mutation createBookingV2($input: BookingInput!) {
    createBooking(input: $input) {
      id
    }
  }
`;

export const UPDATE_BOOKING = gql`
  mutation updateBookingV2($id: Int!, $input: BookingInput!) {
    updateBooking(id: $id, input: $input) {
      status
    }
  }
`;
